import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Container, Row, Col, CardDeck, Card } from "react-bootstrap"
import SignUpComponent from "../../components/sign-up"

const NewsPocamLaunchesVancouverChapter = ({ location }) => {
  return (
    <Layout>
      <SEO
        location={location}
        image="/images/pocam-white-bg.png"
        title="POCAM launches Vancouver Chapter to improve community access to networking and mentorship"
        description="The latest POCAM expansion addresses growing demand for industry-specific spaces where BIPOC advertising and marketing professionals can connect, share knowledge, and access opportunities for career growth."
      />
      <section className="bg-dark text-white py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="8">
              <h1 className="display-4 mb-3">POCAM expands to Vancouver, improving access to community and mentorship for BIPOC professionals in Western Canada</h1>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="10">
              <p>
                <strong>January 30, 2026; Vancouver, BC</strong> – People of Colour in Advertising and Marketing (POCAM), Canada’s leading industry organization focused on advancing equity across advertising, marketing, and creative industries, has launched its newest chapter in Vancouver. The expansion addresses the growing demand for industry-specific spaces where Black, Indigenous, and People of Colour (BIPOC) professionals can connect, share knowledge, and access opportunities for career growth.
              </p>
              <p>
                Following the successful launch of its Montreal chapter in June 2025, POCAM’s new presence will:
              </p>
              <ul>
                <li>increase access to networking and mentorship for BIPOC professionals in the region,</li>
                <li>provide opportunities for POCAM members and industry allies to connect and exchange insights about the local industry, and</li>
                <li>foster collaboration between agencies, freelancers, and brands to strengthen inclusive and equitable industry practices.</li>
              </ul>
              <p>
                “Access to community and mentorship shouldn’t depend on geography,” said POCAM Co-Founder Gavin Barrett. “Our goal with opening the Vancouver chapter is to reach BIPOC professionals who have been forced to navigate the industry without the right support systems in place. Our new presence will unlock the relationships, networks, and advocacy our community needs to thrive.”
              </p>
              <p>
                POCAM’s expansion is a direct response to member feedback. The organization’s <Link to="/visible-and-vocal/">last Visible & Vocal study</Link> revealed declines in workplace inclusion and advancement, with 56% of BIPOC professionals saying positive steps are being taken — down from 67% in 2023 and 73% in 2022. The study also revealed a 2% decline in executive entry and a 4% increase in BIPOC-led mentorship.
              </p>
              <p>
                The Vancouver chapter is focused on building locally relevant programming and partnerships that reflect the region’s industry landscape.
              </p>
              <p>
                “There is an incredible community of non-white marketers and creatives in the Greater Vancouver Area, but historically they haven’t had many opportunities to come together,” said POCAM Steering Committee Member Matthew Tsang, who is based in Vancouver. “This chapter creates a space for people to find mentorship, build meaningful professional relationships, and feel supported as they grow their careers — not just at one event, but over time.”
              </p>
              <p>
                The Vancouver chapter officially launched on Jan. 30 with a community gathering at the Rethink Vancouver office, marking an important milestone in POCAM’s long-term commitment of supporting BIPOC talent and strengthening industry accountability across Canada.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pb-4 pb-lg-5">
        <Container>
          <Row>
            <Col md="10">
              <h3>About POCAM</h3>
              <p>
                Founded in 2020, People of Colour in Advertising and Marketing (POCAM) is a not-for-profit industry organization working to advance representation and equity through mentorship, programming, research, and community-building. POCAM is led by a volunteer Steering Committee of BIPOC advertising and marketing leaders who have made it their mission to empower other BIPOC professionals to succeed within systemically white workplaces. Current Steering Committee members include Ishma Alexander-Huet, Gavin Barrett, Natalie Bomberry, Erik dela Cruz, Joycelyn David, Deyra Jaye Fontaine, Julian Franklin, Aleena Mazhar, Chino Nnadi, Mark Rutledge, Ken Saint Eloy, Justin Senior, and Matthew Tsang.
              </p>
              <p>
                For more information about POCAM, visit <Link to="/">WeArePOCAM.ca</Link>.
              </p>
              <br/>
            </Col>
          </Row>

          <Row>
            <Col md="10">
              <h3>Media contact</h3>
              <p>
                For all media inquiries, please contact us at <a href="mailto:steerco@wearepocam.ca" rel="noreferrer" target="_blank">steerco@wearepocam.ca</a>.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <SignUpComponent />
    </Layout>
  )
}

export default NewsPocamLaunchesVancouverChapter